import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './app.state'
import appActions from './app.action'

export const appSlice = createSlice({
  name: 'app',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },

  extraReducers: (builder) => {
    builder.addCase(appActions.updateAppSidebarShow, (state, action) => {
      state.sideBarShow = action.payload
    })
    builder.addCase(appActions.setLookupData, (state, action) => {
      state.lookup = action.payload
    })
  },
})

export default appSlice.reducer
